import { PRODUCT_CATEGORIES, PRODUCT_TYPES } from "@sdk-point/talisis";

export const getThirdPartyCourseFromCart = (cartItems) => {
    return cartItems.find(item =>
        item.product_category_id === PRODUCT_CATEGORIES.ADDON &&
        item.product_type_id === PRODUCT_TYPES.CURSO
    );
};